import FileUpload from './FileUpload'

export default class ImageFileUpload extends FileUpload {
  constructor(file) {
    super(file);
    this.image = null
  }
}
